import styled from 'styled-components';

export const TechLogoContainer = styled.img`
  width: 40px;
  cursor: pointer;
`;
